var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Auth"},[_c('div',{staticClass:"row auth-position"},[_c('div',{staticClass:"container d-flex flex-column"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }